import React from 'react'
import verifiedStamp from '../../../static/images/verified-stamp.svg'
import { isHumanAdvisorData } from './advisorTypeGuards'
import { getTypeLabel } from './advisorUtils'
import { useAdvisorCard } from './AdvisorCardContext'
import '../../styles/AdvisorCardsModule/AdvisorPhotoProfile.scss'

export const AdvisorPhotoProfile = () => {
  const { advisorData, typeLabels } = useAdvisorCard()
  return (
    <div className='advisor-photo-profile'>
      {advisorData.advisor?.imageUrl && (
        <div className='advisor-photo'>
          <img src={advisorData.advisor.imageUrl} alt={advisorData.advisor?.name}/>
        </div>
      )}
      <div className='advisor-profile-details'>
        <div className='advisor-profile-type'>
          {getTypeLabel(advisorData.advisor?.format, typeLabels)}
          <img src={verifiedStamp} alt='verified'/>
        </div>
        <div className='advisor-profile-name'>{advisorData.advisor?.name}</div>
        {isHumanAdvisorData(advisorData) && (
          <div className='advisor-profile-firm'>{advisorData.advisor.firm}</div>
        )}
      </div>
    </div>
  )
}
